var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 5.20709H13.7721L13.761 5.19605L10.054 1.48895L10.0585 1.48438H10.0429H10H9.98438V1.5V5.25V5.26562H10H13.75H13.7656V5.25V5.20709ZM2.48438 14.5V14.5156H2.5H13.75H13.7656V14.5V6.25V6.23438H13.75H9.01562V1.5V1.48438H9H2.5H2.48438V1.5V14.5ZM14.7344 4.79938V15.4844H1.51562V0.515625H10.4506L14.7344 4.79938Z",
    fill: "#252525",
    stroke: "#FDFDFD",
    strokeWidth: 0.03125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.25H11.25V10.25H4.25V9.25Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.75H11.25V12.75H4.25V11.75Z",
    fill: "#252525"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.bd75446a5e63098a380709ae7f6a9c38.svg";
export { ForwardRef as ReactComponent };